import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

const Modal = ({ active, toggleActive, ...props }) => {
    const [domReady, setDomReady] = useState(false);

    useEffect(() => {
        setDomReady(true)
    })

    return (active && domReady) ? ReactDOM.createPortal(
        (
            <div className="modal-wrapper" onClick={() => toggleActive(!active)}>

                <div className="modal-content" onClick={(e) => e.stopPropagation()}>

                    {props.children}

                </div>

            </div>
        ), document.getElementById('modal-container'))
        : null;
}

export default Modal;